import { Component } from '@theme/component';

class NotifyMeHandler extends HTMLElement {
  connectedCallback() {
    this.#bind();
  }

  #bind() {
    const root = this.closest('dialog') || this;
    const form = root.querySelector('.notify-modal-form');
    const submitButton = root.querySelector('.notify-me__submit');
    const spinner = root.querySelector('.loading__spinner');
    const successContent = root.querySelector('#notifyMeSuccess');
    const content = root.querySelector('#notifyMeContent');
    const closeButton = root.querySelector('.notify-me__close');

    if (!form || !submitButton || !spinner) return;

    closeButton?.addEventListener('click', () => {
      if (successContent && content) {
        successContent.style.display = 'none';
        content.style.display = 'block';
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      submitButton.classList.add('loading');
      spinner.style.display = 'inline-block';

      const email = /** @type {HTMLInputElement} */ (form.elements.namedItem('notifyMeEmail'))?.value;
      const klaviyoId = /** @type {HTMLInputElement} */ (form.elements.namedItem('klaviyoId'))?.value;
      const variantId = /** @type {HTMLInputElement} */ (form.elements.namedItem('variant'))?.value;
      const isPushAllowed = /** @type {HTMLInputElement} */ (form.elements.namedItem('push'))?.checked;

      if (!email || !klaviyoId || !variantId) {
        submitButton.classList.remove('loading');
        spinner.style.display = 'none';
        return;
      }

      try {
        await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoId}`, {
          method: 'POST',
          headers: {
            revision: '2024-02-15',
            accept: 'application/json',
            'content-type': 'application/json',
            'x-klaviyo-onsite': '1',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`,
                  },
                },
              },
            },
          }),
        });

        submitButton.classList.remove('loading');
        spinner.style.display = 'none';
        if (successContent && content) {
          successContent.style.display = 'block';
          content.style.display = 'none';
        }

        const pushowl = /** @type {any} */ (window)['pushowl'];
        if (isPushAllowed && pushowl && typeof pushowl['registerForEvent'] === 'function') {
          pushowl['registerForEvent']('modal-dialog', false);
        }
      } catch (error) {
        submitButton.classList.remove('loading');
        spinner.style.display = 'none';
        console.error('Failed to subscribe to back in stock', error);
      }
    });
  }
}

if (!customElements.get('notify-me-handler')) customElements.define('notify-me-handler', NotifyMeHandler);


